export default __webpack_public_path__ + "static/media/b5.51165ead.jpeg";